import React from 'react'
import moment from 'moment'
import Slider from '../Slider'
import styled, { css } from 'styled-components'
import { BOOKINGS } from 'constants/index'
import { I18n } from 'react-redux-i18n'

const TimelineMark = styled.div`
  ${(props) =>
  props.withButton
    ? css`
          button {
            transform: translateY(10px);
          }
        `
    : css`
          transform: translateY(-50px);
          line-height: normal;
        `}

  .date {
    font-size: 0.85em;
  }
`

export default function Index(props) {
  const { actions = [], bookedForDate = '', bookedOn = '', type } = props
  const dateValueToPercent = (a = null) => (b) =>
    Math.floor((((a ? new Date(a) : new Date()) - new Date(bookedOn)) / (new Date(b) - new Date(bookedOn))).toFixed(4) * 100)

  const nowValue = dateValueToPercent()(bookedForDate)
  const max = 100
  const timelineBooked = type === BOOKINGS.type.flight ? BOOKINGS.timeline.booked : BOOKINGS.timeline.booked
  const timelineFinished = type === BOOKINGS.type.flight ? BOOKINGS.timeline.finished : BOOKINGS.timeline.finished

  const getTimelineActions = (_nowValue) =>
    actions.reduce((prev, action, idx) => {
      if (!action.limitDate) return null
      const limitDate = action.limitDate
      const actionValue = dateValueToPercent(limitDate)(bookedForDate)
      const nextAction = actions[idx + 1]

      // eslint-disable-next-line no-unused-vars
      let isActive = false

      const newVal = {
        [actionValue]: {
          label: (
            <TimelineMark style={{ transform: idx % 2 === 0 ? 'translateY(0px)' : 'translateY(-50px)' }}>
              <div>{getText(action.type)}</div>
              <div className='date'>{moment(limitDate, 'YYYY-MM-DD').format('L')}</div>
            </TimelineMark>
          ),
        },
      }

      if (nextAction !== undefined) {
        const nextValue = dateValueToPercent(nextAction.limitDate)(bookedForDate)

        if (nowValue > 0) {
          if (idx === 0 && nowValue < actionValue) {
            isActive = true
          } else if (nowValue >= actionValue && nowValue < nextValue) {
            isActive = true
          }
        }
      } else if (idx === 0) {
        if (nowValue < actionValue) {
          isActive = true
        } else {
          if (nowValue <= 100) {
            newVal[nowValue] = ''
          }
        }
      }

      return Object.assign(prev, newVal)
    }, {})

  const getCurrentMark = () => {
    const currentValue = dateValueToPercent()(bookedForDate)
    const mark = <TimelineMark />
    return { [currentValue]: mark }
  }

  const marksInTimeline = () => {
    return {
      0: (
        <TimelineMark>
          <div>{I18n.t(timelineBooked)}</div>
          <div className='date'>{moment(bookedOn, 'YYYY-MM-DD').format('L')}</div>
        </TimelineMark>
      ),
      ...getCurrentMark(),
      ...getTimelineActions(nowValue),
      100: (
        <TimelineMark>
          <div>{I18n.t(timelineFinished)}</div>
          <div className='date'>{moment(bookedForDate, 'YYYY-MM-DD').format('L')}</div>
        </TimelineMark>
      ),
    }
  }

  const getText = (type) => {
    const _type = BOOKINGS.actions[type] || type
    return I18n.t(_type)
  }

  return (
    <Slider
      className='mt-3'
      name='actions'
      step={max / actions.length}
      min={0}
      max={max}
      defaultValue={nowValue}
      value={nowValue}
      marks={marksInTimeline()}
      disabled
    />
  )
}
